import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export async function GetProducts(payload) {
  return await axios.get(`${stage_url}api-business-v3/products`, {
    params: payload,
    headers: Headers.getHeaders(true),
  });
}

export async function addProducts(payload) {
  return await axios.post(
    `${stage_url}mydukan-analytics/product/add`,
    payload,
    {
      headers: Headers.getDukanHeaders(true),
    }
  );
}

export async function editProducts(payload) {
  return await axios.put(
    `${stage_url}mydukan-analytics/product/update`,
    payload,
    {
      headers: Headers.getDukanHeaders(true),
    }
  );
}

export async function getProductById(product_id) {
  return await axios.get(
    `${stage_url}mydukan-analytics/product/${product_id}`,
    {
      headers: Headers.getHeaders(true),
    }
  );
}

export async function addPrices(payload, product_id) {
  return await axios.post(
    `${stage_url}/mydukan-analytics/product/${product_id}/price/add`,
    payload,
    {
      headers: Headers.getDukanHeaders(true),
    }
  );
}

export async function editPrices(payload, product_id) {
  return await axios.put(
    `${stage_url}mydukan-analytics/product/${product_id}/price/update`,
    payload,
    {
      headers: Headers.getDukanHeaders(true),
    }
  );
}

export async function getGroups() {
  return await axios.get(`${stage_url}api-business-v3/groups`, {
    headers: Headers.getHeaders(true),
  });
}

export async function addColors(payload, product_id) {
  return await axios.post(
    `${stage_url}mydukan-analytics/product/${product_id}/color/add`,
    payload,
    {
      headers: Headers.getDukanHeaders(true),
    }
  );
}

export async function getImages(payload) {
  return await axios.get(`${stage_url}api-business-v3/growbiz/product/image`, {
    params: payload,
    headers: Headers.getHeaders(true),
  });
}

export async function uploadImages(payload) {
  return await axios.post(`${stage_url}api-business-v3/image/upload`, payload, {
    headers: Headers.getHeaders(true),
  });
}

export async function addImage(payload) {
  return await axios.post(
    `${stage_url}api-business-v3/growbiz/product/image/add`,
    payload,
    {
      headers: Headers.getHeaders(true),
    }
  );
}

export async function removeImage(payload) {
  return await axios.post(
    `${stage_url}api-business-v3/growbiz/product/image/remove`,
    null,
    {
      params: payload,
      headers: Headers.getHeaders(true),
    }
  );
}
